module.exports = __webpack_public_path__ + "img/s9limg2.505f5750.png";